<script lang="ts">
export interface ProseH2Props {
  id?: string
  class?: any
}

export interface ProseH2Slots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseH2Props>()
defineSlots<ProseH2Slots>()
</script>

<template>
  <h2
    :id
    class="mb-4 mt-10 text-lg font-semibold"
    :class="props.class"
  >
    <a
      v-if="id"
      :href="`#${id}`"
    >
      <slot />
    </a>
    <slot v-else />
  </h2>
</template>
